<template>
  <div class="player-block">
    <!--<img :src="require(`@/assets/img/defaultPlayer.png`)" />   @click="goTodetail(item)"-->
    <img
      :src="(item.imageUrl.includes('.png') || item.imageUrl.includes('.jpg')) ? item.imageUrl : require(`@/assets/img/defaultPlayer.png`)"
    />
    <div class="content">
      <div class="info">
        <h5>
          {{item.number}}
          <span>{{item.name}}</span>
          {{item.lastName}}
        </h5>
        <h6>{{item.participantPosition.name}}</h6>
        <div>
          <h4>
            appearences
            <span>{{appearences}}</span>
          </h4>
          <h4>
            goals
            <span>{{goals}}</span>
          </h4>
          <h4>
            assists
            <span>{{assists}}</span>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      img: this.item.img,
    };
  },
  computed: {
    appearences() {
      var playedGames = 0;
      this.item.participantStats.map((el) => {
        playedGames += el.playedGames;
      });
      return playedGames;
    },
    goals() {
      var goals = 0;
      this.item.participantStats.map((el) => {
        goals += el.goals;
      });
      return goals;
    },
    assists() {
      var assists = 0;
      this.item.participantStats.map((el) => {
        assists += el.assists;
      });
      return assists;
    },
  },
  methods: {
    goTodetail(playerId) {
      this.$router.push({ name: "single-player", params: { id: playerId.id } });
    },
  },
};
</script>
<style lang="scss" scoped>
.player-block {
  width: 100%;
  background-image: url("./../../assets/img/card-bg-dark.jpg");
  background-size: 100% 100%;
  background-position: center;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  position: relative;
  padding: 3rem 1.75rem 2.5rem;
  padding-top: 61%;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  //cursor: pointer;
  @media only screen and (max-width: 1199px) {
    padding-top: 0;
    height: 29rem;
  }
  @media only screen and (max-width: 768px) {
    padding-top: 40%;
  }
  &:after {
    position: absolute;
    bottom: 0;
    left: 0;
    content: "";
    width: 100%;
    height: 100%;
    background: linear-gradient(
      359.76deg,
      #111116 12.71%,
      rgba(0, 0, 0, 0) 45.39%
    );
    z-index: 1;
    transition: all 0.3s ease-in-out;
  }
  img {
    position: absolute;
    left: 50%;
    bottom: 1px;
    transform: translateX(-50%);
    z-index: 1;
    max-width: 100%;
    height: 90%;
    max-height: 100%;
    transition: all 0.3s ease-in-out;
    @media only screen and (max-width: 992px) {
      max-width: 116%;
    }
    @media only screen and (max-width: 640px) {
      max-width: 98%;
    }
    @media only screen and (max-width: 400px) {
      max-width: initial;
      bottom: -0.5rem;
      height: 95%;
    }
  }
  &:hover {
    background-size: 105% 105%;
    img {
      height: 95%;
    }
    .info {
      top: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    &:hover {
      .info {
        top: 10rem;
      }
    }
  }
  &.small {
    padding: 0 10px;
    padding-top: 18%;
    padding-bottom: 0;
    background-image: url("./../../assets/img/card-bg-dark.jpg");
    border-radius: 4px;
    .content {
      h5 {
        font-size: 2.5rem;
      }
      h6 {
        font-size: 1.4rem;
      }
      h4 span {
        font-size: 2.2rem;
        line-height: 3rem;
      }
    }
    .content .info {
      top: 8rem;
    }
    .content .info div {
      padding-top: 1rem;
      height: 8rem;
    }
    img {
      max-height: 150%;
      height: 120%;
      max-width: 150%;
      top: 1%;
    }
    &:hover {
      .content .info {
        top: 0;
      }
    }
  }
}
.content {
  height: 100%;
  width: 100%;
  * {
    position: relative;
    z-index: 9;
  }
}
.content {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  color: #fff;
  z-index: 9;
  overflow: hidden;

  .info {
    top: 10rem;
    transition: all 0.3s ease-in-out;
    div {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: space-evenly;
      -ms-flex-pack: space-evenly;
      justify-content: space-evenly;
      padding-top: 1.9rem;
      position: relative;
      height: 8rem;
      @media only screen and (max-width: 1199px) {
        padding: 0;
        height: 8rem;
      }
      h4 {
        min-width: 9rem;
      }
      &:before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        width: 100%;
        height: 1px;
        background: rgba(235, 239, 239, 0.1);
      }
    }
  }

  h5 {
    font-size: 3rem;
    line-height: 2.5rem;
    font-weight: 600;
    text-align: center;
    margin-bottom: 1.5rem;
    @media only screen and (max-width: 768px) {
      font-size: 2.5rem;
      line-height: 2rem;
      margin-bottom: 1rem;
    }
    span {
      font-weight: 400;
    }
  }
  h6 {
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 400;
    text-align: center;
    color: #fff;
    margin-bottom: 1.9rem;
    text-transform: capitalize;
    letter-spacing: 0.5px;
    font-family: $Rob;
  }
  h4 {
    color: #fbbb00;
    font-size: 1.2rem;
    text-transform: uppercase;
    font-weight: 500;
    text-align: center;
    letter-spacing: 0.5px;
    line-height: 2.85rem;
    span {
      display: block;
      font-weight: 700;
      font-size: 2.6rem;
      color: #fff;
    }
  }
}
</style>